export default function(){
	let tooltipTimeout;
	let tooltipTarget;
	let request = undefined;
	const $form = $('.filters__form');

	$(document).on('click', '.js-filters-toggler', function(){
		$('.filters').toggle();
		$('body').toggleClass('js-modal-opened');
	});

	$form.on('submit', function(e){
		e.preventDefault();
		if (request !== undefined) {
			request.abort();
		}
		const $filtersWrapper = $(this).closest('.filters');
		let filterIsActive = false;
		const fields = $(this).serializeArray();
		const params = [];
		for (let i = 0; i < fields.length; i++) {
			if (fields[i].value !== '') {
				params.push(fields[i].name + '=' + fields[i].value);
				filterIsActive = true;
			}
		}
        $filtersWrapper.toggleClass('filters--active', filterIsActive);
		const url = '?' + params.join('&');

		request = $.get(url+'&_=_', function(html) {
			const $tmp = $('<div></div>').html(html);
			const $productsBlock = $('.js-products');
			const $newProductsBlock = $tmp.find('.js-products').html();
			$productsBlock.html($newProductsBlock);
			$('.shop-page__subcategories').html($tmp.find('.shop-page__subcategories').html());
			const countFinded = Number($tmp.find('.js-products-count').html());
			const isEmptyProductsList = countFinded === 0 ? true : false;
			const pluralForms = $('.catalogreviews-page').length > 0 ? ['отзыв', 'отзыва', 'отзывов'] : ['товар', 'товара', 'товаров'] ;
			$('.products').toggleClass('products--not-found', isEmptyProductsList);
			$filtersWrapper.find('.filters__btn').html(`Показать (${countFinded})`);
			setTooltip(`${plural(countFinded, ['Найден', 'Найдено', 'Найдено'])} ${countFinded} ${plural(countFinded, pluralForms)}`);
			toggleResetBlock($filtersWrapper, $tmp);
			$(document).trigger('update_products');
			Update($('.sorting-options'));
			$(document).trigger('products_filtered', html);
			if (tooltipTimeout) {
			    clearTimeout(tooltipTimeout);
            }
			tooltipTimeout = setTimeout(function(){
		        $('.filters__tooltip').fadeOut();
		        clearTimeout(tooltipTimeout);
	        }, 1000);

			if (!!(history.pushState && history.state !== undefined)) {
				window.history.pushState({}, '', url);
			}
		});

	});

	$form.on('filter_changed', '.filter', function(e, tooltipAnchor){
		tooltipTarget = $(tooltipAnchor);
	});

	function setTooltip(text) {
		if (tooltipTarget !== undefined && tooltipTarget.length > 0) {
			const tooltipArea = tooltipTarget[0];

			if (tooltipArea) {
				const tooltipAreaCoords = tooltipArea.getBoundingClientRect();
				const tooltipLeft = tooltipTarget.closest('.filter__inner')[0].getBoundingClientRect().right + 6;
				const tooltipTop = window.pageYOffset + tooltipAreaCoords.top + (tooltipAreaCoords.bottom
					- tooltipAreaCoords.top) / 2 - 18;
				$('.filters__tooltip').html(text).css({
					top: `${tooltipTop}px`,
					left: `${tooltipLeft}px`
				}).fadeIn();
			}
		}
		tooltipTarget = $();
	}


	function plural(count, forms = ['один', 'два', 'пять']) {
		if (Math.floor(count / 10) % 10 !== 1 && 1 <= count % 10 && count % 10 <= 4) {
		  if (count % 10 === 1) {
		    return forms[0];
		  } else {
		    return forms[1];
		  }
		} else {
		    return forms[2];
		}
	}

	function toggleResetBlock($filtersWrapper, $page) {
		if (ResponsiveUtil.isToTablet()) {
			const $resetFilters = $page.find('.filters-list__clear');
			const $filtersResetBlock = $filtersWrapper.find('.filters__reset');

			if ($resetFilters.length > 0 && $filtersResetBlock.length === 0) {
				const $filtersHeader = $filtersWrapper.find('.filters__header');
				const $resetBlock = $(
					'<div class="filters__reset"><button class="filters__reset-btn js-filter-reset btn btn--transparent-gray" type="button">Сбросить всё</button></div>');

				$filtersHeader.append($resetBlock);
			} else if ($resetFilters.length === 0) {
				$filtersResetBlock.remove();
			}
		}
	}

	toggleResetBlock($('.filters'), $('.shop-page__content'));

	$('.filters__form .filter__search-field').each(function() {
		var $searchField = $(this);
		var $filterBlock = $searchField.closest('.filter');
		var $filterItemsWrapper = $filterBlock.find('.filter__inner');
		var $filterItems = $filterItemsWrapper.find('.filter__item');

		$searchField.on('input', function() {
			var value = $searchField.val().toLowerCase();
			$filterItemsWrapper.scrollTop = 0;

			$filterItems.each(function() {
				var $filterItem = $(this);
				var $filterItemLabel = $filterItem.find('.filter__item-label');
				var $seofilterLink = $filterItemLabel.find('.filter-link');

				if ($seofilterLink.length > 0) {
					$filterItemLabel = $seofilterLink;
				}

				var labelText = $filterItemLabel.text().toLowerCase();

				if (labelText.indexOf(value) === -1) {
					$filterItem.hide();
				} else {
					$filterItem.show();
				}
			})
		});
	})

	const $reviewsBlock = $('.catalog-page__reviews-block');

	if ($reviewsBlock.length) {
			$(document).on('products_filtered', function (e, html) {
					const $oldReviewsLink = $reviewsBlock.find('.block__header .link');
					const oldHref = $oldReviewsLink.attr('href');
					const $newReviewsLink = $(html).find('.catalog-page__reviews-block .block__header .link');
					const newHref = $newReviewsLink.attr('href');

					if (oldHref === newHref) {
							return;
					}

					$oldReviewsLink.attr('href', newHref);
			})
	}
}
